<nz-layout class="h-100">
  <!-- ENCABEZADO -->
  <nz-page-header *ngIf="!hideHeader" [nzTitle]="nzBreadcrumb" [class.hide]="(screenService.isMobile$ | async) && !showGlobalSearch">
    <ng-template #nzBreadcrumb>
      <div class="flex-center-between">
        <nz-breadcrumb class="flex-center">
          <!--          <button style="margin-right: 6px" nz-button nzType="text" nzShape="circle" nzSize="default">-->
          <!--            <app-st-icon class="text-dark" [bold]="true" name="arrow_back"></app-st-icon>-->
          <!--          </button>-->

          @if (!(screenService.isMobile$ | async)) {
            <!--   Desktop   -->
            <ng-container>
              <nz-breadcrumb-item>
                <!--                <span class="text-label-14 text-semibold cursor-pointer">Maestros</span>-->
                <!--                 /-->
                <span>{{ maestroName }}</span>
              </nz-breadcrumb-item>
            </ng-container>
          } @else {
            <!--   Mobile   -->
              <!--            <ng-container *ngIf="(breadcrumb$ | async) as breadcrumb">-->
              <!--              &lt;!&ndash;  Si el length del breadcrumb es 3 es que se esta en el detalle de Servicios  &ndash;&gt;-->
              <!--              <app-st-icon *ngIf="breadcrumb.length === 3" style="margin-right: 5px"-->
              <!--                           [avatar]="true" [smallAvatar]="true"-->
              <!--                           [name]="gs.getServiceType(selectedService?.typeId || 0)?.icon || 'close'">-->
              <!--              </app-st-icon>-->

              <!--              <nz-breadcrumb-item>-->
              <!--                <span class="text-header-16">{{ breadcrumb[breadcrumb.length - 1].label }}</span>-->
              <!--              </nz-breadcrumb-item>-->
              <!--            </ng-container>-->
          }
        </nz-breadcrumb>
      </div>
    </ng-template>

    <nz-page-header-extra>
      <app-global-searchbar
        [ngClass]="{'hide': (screenService.isMobile$ | async) && !showGlobalSearch}"></app-global-searchbar>
    </nz-page-header-extra>
  </nz-page-header>

  <!-- CONTENEDOR PRINCIPAL -->
  <div class="maestro-wrapper" [class.gap-0]="(screenService.isMobile$ | async) &&showGlobalSearch">
    <!-- Mostrar busqueda y filtros avanzados (Mobile) -->
    <div class="mobile-search-filter">
      <button (click)="openFormDrawer()" nzShape="circle" nzSize="default" nz-button nzType="text">
        <app-st-icon [bold]="true" name="add"></app-st-icon>
      </button>
      <button (click)="toggleSearch($event)" nzShape="circle" nzSize="default" nz-button nzType="text">
        <app-st-icon [bold]="true" name="search"></app-st-icon>
      </button>
      <button (click)="toggleGlobalSearch($event)" nzShape="circle" nzSize="default" nz-button nzType="text">
        <app-st-icon [bold]="true" name="travel_explore"></app-st-icon>
      </button>
    </div>

    <h1 *ngIf="!(screenService.isMobile$ | async)">{{ maestroName }}</h1>
    <div class="flex-center-between">
      <div class="flex gap-200" style="flex: 1; flex-wrap: wrap;">
        <app-pocket-searchbar [class.hide]="(screenService.isMobile$ | async) && !showSearch"
                              [class.w-100]="(screenService.isMobile$ | async)"
                              [(searchValue)]="searchValue"
                              (searchEvent)="filter()"></app-pocket-searchbar>

        <!-- Componente de filtro -->
        <app-maestro-filter
          *ngIf="enableFilters"
          [filterableColumns]="filterableColumnsList"
          (filterChange)="onFilterChange($event)"
          (filterClear)="onFilterClear()">
        </app-maestro-filter>

        <div
          *ngIf="enableGrouping && groupableColumnsList.length > 0"
          (click)="openGroupDrawerRef()"
          class="st-badget"
          [ngClass]="activeGroupColumns.length > 0 ? 'black' : 'subtle-grey'"
        >
          <label>Agrupar por</label>
          <app-st-icon class="sufix" *ngIf="activeGroupColumns.length === 0"
                       [name]="'arrow_drop_down'"></app-st-icon>
          <span *ngIf="activeGroupColumns.length > 0" class="filter-not sufix">{{
              activeGroupColumns.length
            }}</span>
        </div>
      </div>

      <div *ngIf="!(screenService.isMobile$ | async)" class="flex gap-200">
        <button *ngIf="secondaryBtnText" (click)="emitSecondaryBtnClick()"
                class="flex-center-between" nz-button nzType="default" nzShape="round" nzSize="default">
          <app-st-icon *ngIf="ms.secondaryLoading$ | async" class="prefix" name="progress_activity"></app-st-icon>
          {{ secondaryBtnText }}
        </button>

        <button *ngIf="showCheckboxes && selectedIds.length > 0 && permissions.delete"
                (click)="openDeleteMultipleConfirmation()"
                class="flex-center" nz-button nzType="default" nzShape="round" nzSize="default" nzDanger>
          <app-st-icon class="prefix" [bold]="true" name="delete"></app-st-icon>
          Eliminar
        </button>

        <button *ngIf="permissions.create" (click)="openFormDrawer()"
                class="flex-center-between" nz-button nzType="primary" nzShape="round" nzSize="default">
          <app-st-icon class="prefix" name="add"></app-st-icon>
          {{ createButtonText }}
          <!--          Crear {{ maestroName | lowercase }}-->
        </button>
      </div>

    </div>

    <nz-table #table [nzData]="renderData" [nzScroll]="{x: (screenService.isMobile$ | async) ? '350px' : 'auto'}"
              class="st-bordered"
              [nzPageSize]="pageSize"
              [nzPageIndex]="pageIndex"
              [nzShowSizeChanger]="showPageSizeSelector"
              [nzPageSizeOptions]="pageSizeOptions"
              (nzPageIndexChange)="pageIndexChange($event)"
              (nzPageSizeChange)="pageSizeChange($event)">
      <tr>
        @if (showCheckboxes) {
          <th [nzAlign]="'center'" [style.width]="'50px'">
            <label nz-checkbox
                   [(ngModel)]="allSelected"
                   [nzIndeterminate]="indeterminate"
                   (ngModelChange)="onSelectAll($event)">
            </label>
          </th>
        }
        @for (column of columnsDataToShow; track column) {
          @if (column.checkboxOnTable && column.pathData?.type !== 'checkboxOnTable') {
            <th [nzAlign]="column.align || 'center'" [style.width]="column.width || '50px'">
              {{ column.name }}
            </th>
          } @else if (column.pathData?.type === 'checkboxOnTable') {
            <th [nzAlign]="column.align || 'center'" [style.width]="column.width || '50px'">
              {{ column.name }}
            </th>
          } @else if (column.checkboxOnTable) {
            <th [nzAlign]="column.align || 'center'" [style.width]="column.width || '50px'">
              <label nz-checkbox
                     [(ngModel)]="allSelected"
                     [nzIndeterminate]="indeterminate"
                     (ngModelChange)="onSelectAll($event)">
              </label>
            </th>
          } @else {
            <th *ngIf="!column.checkbox" [nzAlign]="column.align || null" style="white-space: nowrap; position: relative"
                [class]="getColumnClass(column.name, column.sortable)"
                [style.width]="(screenService.isMobile$ | async) && column.widthMobile
                              ? column.widthMobile
                              : (column.width ? column.width : 'auto')">{{ column.name }}

              <app-st-th-sort *ngIf="column.sortable"
                              [sortDirection]="getColumnSortDirection(column)"
                              (sortEvent)="handleSort(column)"></app-st-th-sort>
            </th>
          }
        }
        <th [style.width]="(screenService.isMobile$ | async) && !showDetails ? '45px' : '76px'" [nzRight]="'0px'"></th>
      </tr>
      <tbody style="width: 20px">
        @for (item of table.data; track item.id) {
          @if (item.__groupRow) {
          <tr
            class="maestro-group-row"
            [attr.aria-expanded]="isGroupExpanded(item)"
            (click)="toggleGroupRow(item, $event)">
            <td [attr.colspan]="getTableColspan()">
              <button
                type="button"
                nz-button
                nzType="text"
                nzShape="circle"
                nzSize="small"
                class="group-expand-button"
                [style.marginLeft.px]="getGroupIndent(item)"
                [attr.aria-expanded]="isGroupExpanded(item)"
                [attr.aria-label]="isGroupExpanded(item) ? 'Contraer grupo' : 'Expandir grupo'"
                (click)="toggleGroupRow(item, $event)">
                <app-st-icon [name]="isGroupExpanded(item) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'" [bold]="true"></app-st-icon>
              </button>
              <span class="group-column-name">{{ item.groupColumnName }}:</span>
              <span class="group-name">{{ item.groupName }}</span>
              <span class="group-count">{{ item.count }}</span>
            </td>
          </tr>
          } @else {
          <tr>
            @if (showCheckboxes) {
              <td [nzAlign]="'center'">
                <label nz-checkbox
                       [ngModel]="selectedIds.includes(item.id)"
                       (ngModelChange)="onSelectItem(item.id, $event)"
                       (click)="$event.stopPropagation()">
                </label>
              </td>
            }
            @for (column of columnsDataToShow; track column) {
              @if (column.optionList && column.optionList.length > 0) {
                @if (column.pathData!.type === 'icon-select') {
                  <td>
                    @if (!!item[column.pathData!.name]) {
                      <app-st-icon [bold]="true" [name]="item[column.pathData!.name]"></app-st-icon>
                    } @else {
                      <span class="color-grey-9">-</span>
                    }
                  </td>
                } @else if (column.pathData!.name === 'managerId' && column.pathData!.nestedPath === 'managerName') {
                  <!-- Caso especial para managerId: usar getNestedDisplayName -->
                  <td [class.color-grey-9]="getNestedDisplayName(item, column.pathData!.name!, column.pathData!.nestedPath) === '-'">
                    {{ getNestedDisplayName(item, column.pathData!.name!, column.pathData!.nestedPath) }}
                  </td>
                } @else {
                  <td [class.color-grey-9]="findOptionNameById(item[column.pathData!.name!], column.optionList!) === '-'">{{ findOptionNameById(item[column.pathData!.name!], column.optionList!) || '-' }}</td>
                }
              } @else {
                @if (column.pathData!.type! == 'date') {
                  <td [class.color-grey-9]="!deepGet(item, column.pathData!.name!)">{{ deepGet(item, column.pathData!.name!) ? ((deepGet(item, column.pathData!.name!) | date:  column.pathData?.dateFormat || "dd/MM/yyyy") | uppercase) : '-' }}</td>
                } @else if (column.pathData!.type! == 'image') {
                  <td>
                    <nz-avatar
                      class="not-max-width"
                      (click)="item[column.pathData!.name!] ? openViewImageModal(item[column.pathData!.name!]) : undefined"
                      [nzSrc]="item[column.pathData!.name!] ? getSafeImageUrl(item[column.pathData!.name!]) : undefined"
                      [nzText]="!item[column.pathData!.name!] ? getInitials(item) : undefined"
                      [style.cursor]="item[column.pathData!.name!] ? 'pointer' : 'default'"
                      [style.backgroundColor]="!item[column.pathData!.name!] ? '#ffffff' : undefined"
                      [style.color]="!item[column.pathData!.name!] ? '#000000' : undefined"
                      [style.border]="!item[column.pathData!.name!] ? '1px solid #d9d9d9' : undefined"
                      [style.fontWeight]="!item[column.pathData!.name!] ? '600' : undefined">
                    </nz-avatar>
                  </td>
                } @else if (column.pathData!.type! == 'avatar-select') {
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <nz-avatar
                        [nzSize]="32"
                        [nzSrc]="getNestedProperty(item, column.pathData!.name!, 'avatar') ? getSafeImageUrl(getNestedProperty(item, column.pathData!.name!, 'avatar')) : undefined"
                        [nzText]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? getInitialsFromNested(item, column.pathData!.name!) : undefined"
                        [style.backgroundColor]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? '#ffffff' : undefined"
                        [style.color]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? '#000000' : undefined"
                        [style.border]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? '1px solid #d9d9d9' : undefined"
                        [style.fontWeight]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? '600' : undefined">
                      </nz-avatar>
                    <span>{{ getNestedDisplayName(item, column.pathData!.name!, column.pathData!.nestedPath) }}</span>
                    </div>
                  </td>
                } @else if (column.pathData!.type! == 'multi-select') {
                  <td style="display: flex;flex-wrap: wrap;">
                    @if (item[column.pathData!.name!] && item[column.pathData!.name!].length > 0) {
                      @for (document of item[column.pathData!.name!]; track document) {
                        <app-doc-badget-status [document]="document"></app-doc-badget-status>
                      }
                    } @else {
                      <span class="color-grey-9">-</span>
                    }
                  </td>
                } @else if (column.checkboxOnTable || column.pathData?.type === 'checkboxOnTable') {
                  <td [nzAlign]="column.align || 'center'">
                    <nz-switch
                      [ngModel]="deepGet(item, column.pathData!.name!)"
                      [nzDisabled]="false"
                      class="readonly-switch"
                      (click)="$event.preventDefault(); $event.stopPropagation();">
                    </nz-switch>
                  </td>
                } @else if (column.pathData!.type! == 'boolean' && column.checkboxOnTable) {
                  <td [nzAlign]="column.align || 'center'">
                    <nz-switch
                      [ngModel]="deepGet(item, column.pathData!.name!)"
                      [nzDisabled]="true"
                      class="readonly-switch"
                      (click)="$event.preventDefault(); $event.stopPropagation();">
                    </nz-switch>
                  </td>
                } @else if (column.pathData!.type! == 'boolean') {
                  <td>{{ item[column.pathData!.name!] ? 'Sí' : 'No' }}</td>
                } @else if (column.pathData!.type! == 'money-rate') {
                  @if (deepGet(item, column.pathData!.name!)) {
                    <td
                      *ngIf="setCurrencyData(deepGet(item, column.pathData!.name!), deepGet(item, 'isoCode'), !!column.pathData?.reverseRate) as currencyData">
                      <div class="flex-center gap-075" style="width: fit-content">
                        <span class="text-label-12">1 {{ currencyData.firstIso }} = </span>
                        <span class="st-badget subtle-grey"
                              style="padding: 6px 7px">{{ currencyData.rate | number: '1.0-4' }} {{ currencyData.lastIso }}</span>
                      </div>
                    </td>
                  } @else {
                    <td class="color-grey-9">-</td>
                  }
                } @else if (column.pathData!.name! === 'formattedState') {
                  <!-- Badge especial para estado de service order -->
                  <td [style.min-width]="column.width || '50px'">
                    <ng-container *ngIf="item.formattedState as stateData">
                      <span
                        class="st-badget text-semibold text-nowrap"
                        [ngClass]="stateData.class"
                        style="display: inline-block;">
                        <app-st-icon *ngIf="stateData.icon" [name]="stateData.icon" [bold]="true" style="margin-right: 4px;"></app-st-icon>
                        <label class="text-nowrap">{{ stateData.name }}</label>
                      </span>
                    </ng-container>
                  </td>
                } @else if (column.pathData!.type! == 'badge'){
                  <td>
                    <nz-badge [nzCount]="item[column.pathData!.name!]"
                              [nzStyle]="{ backgroundColor: '#EBEBEB', color: '#171717', fontWeight:'600',
                              width:'23px', height:'20px', fontSize:'10px', boxShadow:'0 0 0 1px #EBEBEB'}"
                              class="badge-table">
                    </nz-badge>
                  </td>
                } @else if (column.pathData!.type! == 'checkboxOnTable' || column.checkboxOnTable) {
                  <td [nzAlign]="column.align || 'center'">
                    <nz-switch
                      [ngModel]="deepGet(item, column.pathData!.name!)"
                      [nzDisabled]="false"
                      class="readonly-switch"
                      (click)="$event.preventDefault(); $event.stopPropagation();">
                    </nz-switch>
                  </td>
                }@else if(column.pathData!.type! == 'color'){
                  <td>
                    <nz-color-block [nzColor]="item[column.pathData!.name!]"></nz-color-block>
                  </td>
                }@else if(column.pathData!.type! == 'icon'){
                  <td>
                    <app-st-icon [name]="item[column.pathData!.name!]"></app-st-icon>
                  </td>
                } @else if(column.pathData!.type! == 'currency'){
                  <td [class.color-grey-9]="!item[column.pathData!.name!]">
                    {{ item[column.pathData!.name!] ? ('$' + (item[column.pathData!.name!] | number: '1.2-2')) : '-' }}
                  </td>
                } @else {
                  @if (column.pathData?.nestedPath) {
                    <td [class]="getColumnClass(column.name, false, !deepGet(item, column.pathData!.name! + '.' + column.pathData!.nestedPath!))">{{ deepGet(item, column.pathData!.name! + '.' + column.pathData!.nestedPath!) || '-' }}</td>
                  } @else {
                  <td [class]="getColumnClass(column.name, false, column.pathData?.displayFn ? getColumnDisplayValue(item, column) === '-' : !item[column.pathData!.name!])">{{ column.pathData?.displayFn ? getColumnDisplayValue(item, column) : (item[column.pathData!.name!] || '-') }}</td>
                  }
                }
              }
            }
            <td nzAlign="center" class="action-cell" [nzRight]="'0px'">
              <button *ngIf="permissions.edit || permissions.delete" nz-button nzType="text" nzShape="circle"
                      nzSize="default" nz-dropdown
                      [nzDropdownMenu]="item.isoCode !== 'USD' ? actionMenu : null" nzTrigger="click">
                <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
              </button>
              @if (showDetails) {
                <button *ngIf="permissions.viewDetails" (click)="openDetailsDrawer(item)" nz-button nzType="text"
                        nzShape="circle" nzSize="default">
                  <app-st-icon name="right_panel_open" [bold]="true"></app-st-icon>
                </button>
              }
            </td>

            <nz-dropdown-menu #actionMenu="nzDropdownMenu">
              <ul nz-menu>
                <!-- El USD no se puede editar -->
                <li *ngIf="permissions.edit" (click)="openFormDrawer(item)" nz-menu-item>
                  <button nz-button nzType="text" nzShape="circle" nzSize="default"
                          class="flex- flex-center gap-100">
                    <app-st-icon name="edit" [bold]="true"></app-st-icon>
                    <span class="text-label-14 text-dark">Editar</span>
                  </button>
                </li>
                <li *ngIf="permissions.delete" nz-menu-item (click)="openDeleteConfirmation(item.id)">
                  <button class="flex-center gap-100"
                          nz-button nzType="text" nzShape="circle" nzSize="default">
                    <app-st-icon name="delete" [bold]="true"></app-st-icon>
                    <span class="text-label-14 text-dark">Eliminar</span>
                  </button>
                </li>
              </ul>
            </nz-dropdown-menu>
          </tr>
          }
        }
      </tbody>
    </nz-table>

    <nz-empty *ngIf="!tableData?.length" nzNotFoundImage="simple"></nz-empty>
    <ng-template #viewImageModalTmpl>
      <div class="confirm-modal"
           style="display: flex;flex-direction: column;padding: 15px;align-items: center;justify-content: center;">
        <app-st-icon (click)="viewImageModalRef.close()" class="custom-clear" name="close"
                     style="position: absolute;top: 15px;right: 15px;cursor: pointer;"></app-st-icon>
        <img style="max-width: 300px;" src="{{tmpImage }}">
      </div>
    </ng-template>
  </div>
</nz-layout>

<app-confirmation-modal #confirmationModal (confirmed)="onDeleteConfirmed($event)"></app-confirmation-modal>

<ng-template #groupDrawerTmpl>
  <div class="st-drawer-wrapper maestro-group-drawer">
    <div class="st-drawer-header unchange-direction lg-p-x show-border">
      <p class="text-semibold">Agrupar por</p>

      <div class="flex-center gap-200">
        <button *ngIf="!(screenService.isMobile$ | async)" class="flex-center gap-075" (click)="discardGrouping()"
                [nzShape]="'round'" nzSize="default" nz-button
                [nzType]="'default'">
          <app-st-icon [class.prefix]="!(screenService.isMobile$ | async)" class="text-btn-16" [bold]="true"
                       name="cancel"></app-st-icon>
          <span class="text-btn-14">Descartar</span>
        </button>

        <button class="flex-center gap-075" (click)="applyGrouping()"
                [nzShape]="'round'" [nzSize]="(screenService.isMobile$ | async) ? 'small' : 'default'" nz-button
                [nzType]="'primary'">
          <app-st-icon [class.prefix]="!(screenService.isMobile$ | async)" class="text-btn-16" [bold]="true"
                       name="check_circle"></app-st-icon>
          <span class="text-btn-14">Aplicar</span>
        </button>

        <app-st-icon (click)="groupDrawerRef?.close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
      </div>
    </div>

    <ng-container *ngIf="(screenService.isMobile$ | async)" [ngTemplateOutlet]="groupSearchCleanTmpl"></ng-container>

    <div class="st-drawer-content">
      <div class="left-section">
        <ng-container *ngIf="!(screenService.isMobile$ | async)" [ngTemplateOutlet]="groupSearchCleanTmpl"></ng-container>

        <div class="flex flex-column gap-100 overflow-auto">
          @for (column of shownGroupableColumns; track column.name) {
            <div (click)="selectGroupColumn(column)" [class.bg-grey]="column.name === selectedGroupColumn?.name"
                 class="filter-group-section">
              <p style="line-height: 1.7" [class.filters-active]="isDraftGroupColumnActive(column)">{{ column.name }}</p>
              <div class="flex-center gap-100">
                <span *ngIf="getDraftGroupOrder(column) as order" class="filter-not sufix">{{ order }}</span>
                <app-st-icon name="chevron_forward" [bold]="true"></app-st-icon>
              </div>
            </div>
          }
        </div>
      </div>

      <div *ngIf="selectedGroupColumn" class="right-section">
        <div class="flex-center-between">
          <p class="text-header-24">{{ selectedGroupColumn.name }}</p>

          <div (click)="cleanSelectedGroupColumn(selectedGroupColumn)" class="st-badget subtle-grey"
               [class.large]="!(screenService.isMobile$ | async)">
            <label>Limpiar</label>
          </div>
        </div>

        <p class="group-helper-text">
          Selecciona uno o mas valores de este campo. Al aplicar, el listado se organizara solo con las lineas que coincidan con esos valores.
        </p>

        <div class="search-preffix search group-search value-search">
          <input (keydown.escape)="cleanSearchGroupItemValue()" (keydown.enter)="filterGroupItems()"
                 nzSize="default" type="text" nz-input [placeholder]="'Buscar ' + (selectedGroupColumn.name | lowercase) + '...'"
                 [(ngModel)]="searchGroupItemValue"
                 (ngModelChange)="filterGroupItems()"/>
          <app-st-icon *ngIf="searchGroupItemValue" (click)="cleanSearchGroupItemValue()" class="clean-preffix"
                       name="close"></app-st-icon>
        </div>

        <div class="group-values-list">
          <label nz-checkbox
                 class="group-value-option select-all-option"
                 [(ngModel)]="allGroupValuesSelected"
                 [nzIndeterminate]="groupValuesIndeterminate"
                 (ngModelChange)="toggleSelectAllGroupValues($event)">
            <span class="group-value-label text-semibold">Seleccionar todos</span>
          </label>
          <nz-divider style="margin: 4px 0;"></nz-divider>
          @for (option of shownGroupValueOptions; track option.key) {
            <label
              class="group-value-option"
              [ngModel]="option.isActive"
              nz-checkbox
              (ngModelChange)="toggleGroupValue(option, $event)">
              <span class="group-value-label">{{ option.label }}</span>
            </label>
          } @empty {
            <div class="drawer-empty-options">
              No hay valores disponibles para este campo.
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #groupSearchCleanTmpl>
  <div class="flex-center-between searchbar-clean-cont">
    <div class="search-preffix search group-search">
      <input (keydown.escape)="cleanSearchGroupValue()" (keydown.enter)="filterGroupColumns()"
             nzSize="default" type="text" nz-input placeholder="Buscar campos..."
             [(ngModel)]="searchGroupValue"
             (ngModelChange)="filterGroupColumns()"/>
      <app-st-icon *ngIf="searchGroupValue" (click)="cleanSearchGroupValue()" class="clean-preffix"
                   name="close"></app-st-icon>
    </div>

    <div (click)="cleanAllGroups()" class="st-badget subtle-grey" [class.large]="!(screenService.isMobile$ | async)">
      <label>Limpiar</label>
    </div>
  </div>
</ng-template>
